import { updateLead } from "@/services";
import validatePaidCampaign from "@helpers/validatePaidCampaign";
import axios from "axios";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Footer from "@/components/Footer/FooterComponent";
import Header from "@/components/Header/Header";
import SEOHead from "@/components/SEOHead/SEOHead";
import UniversalScheduler from "@/components/UniversalScheduler/UniversalSchedulerV2";
import { WordPressAPI } from "../config";
import { universalSchedulerDefaults } from "../data/universalSchedulerDefaults";

const JoinNowStyles = styled.div`
  padding-bottom: 3rem;
  position: relative;
  overflow: hidden;
  .scheduler-thank-you {
    position: static;
  }
`;

const JoinNow = ({ data }) => {
  const {
    meta_description,
    page_title_tag,
    phone_number_setup,
    additional_questions,
    lead_values: leadValues,
  } = data;
  const [account, setAccount] = useState(null);

  const {
    form: { lead_type, lead_source },
  } = universalSchedulerDefaults;
  const paid_campaign = validatePaidCampaign(data.paid_campaign);

  useEffect(() => {
    const sessionAccount = sessionStorage.getItem("account");

    if (sessionAccount) {
      setAccount(JSON.parse(sessionAccount));
    }
  }, []);

  const addDistributedDate = async (data) => {
    // add distribute date

    const { response, selectedAppointment } = data;

    await updateLead({
      Distribute_Date__c: selectedAppointment.selectedDate,
    });
  };

  return (
    <div>
      <SEOHead>
        <title>{page_title_tag}</title>
        <meta key="description" name="description" content={meta_description} />
        <meta name="robots" content="noindex" />
      </SEOHead>
      <Header
        AdditionalQuestions={additional_questions}
        phone_number={phone_number_setup}
        leadValues={leadValues}
        PaidCampaign={paid_campaign}
      />
      <JoinNowStyles>
        <UniversalScheduler
          account={account}
          data={universalSchedulerDefaults}
          leadValues={leadValues}
          phoneNumber={phone_number_setup}
          PaidCampaign={paid_campaign}
          restartOnClose
          AdditionalQuestions={additional_questions}
          callBack={(data) => addDistributedDate(data)}
          hideCloseButton={true}
        />
      </JoinNowStyles>
      <Footer phone_number={phone_number_setup} />
    </div>
  );
};

export const getStaticProps = async () => {
  const { data } = await axios.get(`${WordPressAPI.pages}/11052`);
  return {
    props: {
      data: data.acf,
    },
    // revalidate: 1,
  };
};

export default JoinNow;
